import Design1 from './design-1';

import './index.css';
import {WebsiteContext} from "../../index";
import {useContext, useEffect, useState} from "react";
import axios from "axios";

export default function ListOfItemsBlock(props) {
    const context = useContext(WebsiteContext);
    const [imageWidth, setImageWidth] = useState(1184);
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        props?.values?.options?.listItemsMobileDisplay === 'scroll' && window.innerWidth < 1024
            ? setImageWidth(256)
            : window.innerWidth < context.breakpoint
                ? setImageWidth(Math.round(412 / (props?.values?.options?.columnsMobile ?? 1)))
                : setImageWidth(Math.round(1184 / (props?.values?.options?.columns ?? 1)))
    }, []);

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();
        if (!context.builder) setLocations(context.website.departments)
        else {
            axios.get(`/api/v2/departments?activeOnly=true`, {cancelToken: cancelToken.token})
                .then(({data}) => {
                    setLocations(data);
                })
                .catch(err => {
                    if (!axios.isCancel(err)) console.log(err);
                });
        }
        return () => cancelToken.cancel();
    }, []);

    let DesignBlock;

    switch (props.values?.design) {
        case 0 :
            DesignBlock = Design1;
            break;
        default:
            DesignBlock = Design1;
    }

    return (
        <DesignBlock {...props} imageWidth={imageWidth} locations={locations}/>
    )
}